import api from "./api.js";

export default class PopupApi {
  static async create(data) {
    return await api.post(`popup`, data);
  }
  static async getList(data) {
    return await api.get(`popup`, data);
  }
  static async getById(id) {
    return await api.get(`popup/${id}`);
  }
  static async update(id, data) {
    return await api.patch(`popup/${id}`, data);
  }
  static async delete(data) {
    return await api.del(`popup`, data);
  }
  static async updateActivation(id, data) {
    return await api.patch(`popup/activation/${id}`, data);
  }
}
